import { getDataMapper, mapField, mapArray } from "@/shared";

export const mapRentToCloseToServer = getDataMapper({
    rent_id: mapField("id", Number),
    add_payed: mapField("additionalPayment", Number),
    pay_type_id: mapField("additionalPaymentType", Number),
});

export const mapRentsToCloseToServer = mapArray(mapRentToCloseToServer);
